import {
  FullAvigilonIntegration,
  AvigilonIntegrationCreatePayload,
  AvigilonIntegrationResponse,
  AvigilonIntegrationUpdatePayload,
  AvigilonOrganizationListResponse,
  CoreIntegrationTypes,
  AvigilonExternalIdResponse,
} from "../types/core-integration-types";
import {
  CoreIntegrations,
  CORE_INTEGRATIONS_BASE_PATH,
} from "./core-integrations";

const AVIGILON_ENTRIES_URL = "/v1/integrations/avigilon/entries";

export class AvigilonClient extends CoreIntegrations {
  async createAvigilonIntegration(payload: AvigilonIntegrationCreatePayload) {
    return super.create<
      AvigilonIntegrationCreatePayload,
      AvigilonIntegrationResponse
    >(CoreIntegrationTypes.avigilon, payload);
  }

  async delete(id: string) {
    return super.delete(id);
  }

  async updateAvigilonIntegration(id : string, payload : AvigilonIntegrationUpdatePayload) {
    return super.update<
      AvigilonIntegrationUpdatePayload,
      AvigilonIntegrationResponse
    >(id, payload);
  }

  async fetchAvigilonIntegration(id: string) {
    return super.fetch<Partial<FullAvigilonIntegration>>(id);
  }

  async fetchOrganizations() {
    let res = null;
    try {
      res = super.requestWithStatus<AvigilonOrganizationListResponse>(
        "GET",
        `${CORE_INTEGRATIONS_BASE_PATH}/avigilon/organizations`
      );
    } catch (e) {
      console.error(e);
      throw e;
    }

    return res;
  }

  async integrationIsInstalled() {
    return super.isInstalled<AvigilonIntegrationResponse>(
      CoreIntegrationTypes.avigilon
    );
  }

  async fetchAvigilonExternalIds() {
    return super.requestWithStatus<AvigilonExternalIdResponse>(
      "GET",
      AVIGILON_ENTRIES_URL
    );
  }
}
